t = require('views/internal/teacup-with-helpers')('org_member_activity')
Auth = require 'db/auth'
View = require 'view'
l = require 'lib/localize'
Util = require 'lib/util'
trackUe = require 'debug/trackUe'


template = t.renderable ({ name, url, memberType, canBeRemoved, backgroundColor, backgroundImageThumbnail }) ->
  t.li ->
    t.a '.u-clearfix', {
        href: url,
        class: t.classify({ 'removable': canBeRemoved })
      }, ->
      t.div '.org-board-tile', ->
        t.div '.thumbnail', {
            style: t.stylify
              'background-color': backgroundColor,
              'background-image': if backgroundImageThumbnail then "url('#{backgroundImageThumbnail}')" else 'none'
          }
        t.div '.org-board-name', ->
          t.span ->
            t.text name
            t.text ' '
            t.span '.quiet', ->
              t.format 'membertype', { memberType }

      if canBeRemoved
        t.button '.js-remove-from-board', ->
          t.format 'remove'

module.exports = class OrganizationBoardForMemberView extends View
  initialize: ({ @member, @organizationBoardCount }) ->
    super

  events:
    'click .js-remove-from-board': 'removeFromBoard'

  removeFromBoard: (e) ->
    Util.stop(e)
    @model.removeMember(@member)
    @member.boardList.remove(@model)
    trackUe(
      "team members view",
      "removes",
      "member",
      "",
      "board",
      "member boards pop-over",
      {
        "organization_board_count": @organizationBoardCount
        "remover_member_id": Auth.myId(),
        "removed_member_id": @member.id,
        "id_board": @model.id,
        "id_organization": @model.get('idOrganization')
      }
    )

  render: ->
    backgroundTile = !!@model.getPref('backgroundTile')
    backgroundImage = @model.getPref('backgroundImage')
    backgroundImageThumbnail = if backgroundTile then backgroundImage else Util.smallestPreviewBiggerThan(@model.getPref('backgroundImageScaled'), 400, 200)?.url ? backgroundImage
    backgroundColor = @model.getPref('backgroundColor')

    @$el.html(
      template({
        url: @model.getUrl()
        name: @model.get('name')
        memberType: l(['member types', @model.getMemberType(@member)])
        canBeRemoved: @model.canRemoveMember(@member)
        backgroundColor,
        backgroundImageThumbnail
      })
    )

    @



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-board-for-member-view.coffee